import React from "react";
import { useParams } from "react-router-dom";
import { ProjectItems } from "./data/ProjectItems";

export default function SingleProject() {
  let { id } = useParams();

  const hexValue = `#${ProjectItems[id].hexColor}`;

  return (
    <div className="single-project">
      <a href="/projects" className="projects-link">
        <i className="ri-arrow-left-s-line"></i>Return to all projects
      </a>
      <div className="single-project__header">
        <div
          className="single-project__header--txt"
          style={{ backgroundColor: `${hexValue}` }}
        >
          <h1>{ProjectItems[id].title}</h1>
          <h2>{ProjectItems[id].type}</h2>
        </div>
        <img src={ProjectItems[id].image} alt={ProjectItems[id].title} style={{ border: `2px solid ${hexValue}` }}/>
      </div>
      <div className="single-project__content">
        <div className="single-project__content--tags">
          {ProjectItems[id].tags.map(function (tags, i) {
            return (
              <p key={i}>
                <i className="ri-arrow-right-s-line"></i>
                {tags.name}
              </p>
            );
          })}
        </div>
        <p className="single-project__content--desc">
          {ProjectItems[id].description}
        </p>
        <div className="single-project__content--btns">
          <a
            href={ProjectItems[id].url}
            target="_blank"
            rel="noopener noreferrer"
          >
            Visit Website <i className="ri-global-line"></i>
          </a>
          <a
            href={ProjectItems[id].gitUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            Visit GitHub <i className="ri-github-fill"></i>
          </a>
        </div>
      </div>
    </div>
  );
}
